import Header from '@/features/Header';
import MainLayout from '@/shared/layouts/MainLayout';
import Landing from '@/widgets/Landing';
import Footer from '@/features/Footer';
import { 
  useMinerAccount,
} from "@/processes/MinerAccounts";
import { wrapper } from '@/global/store';
import { SEO } from '@/processes/Router';
import { withUserDataFromCookie } from '@/processes/Auth';
import JsonLdSchema from "@/processes/Router/components/JsonLdSchema";
import BannerTop from '@/shared/ui/BannerTop';

export default function Home() {
  const { isAuth, isAccounting } = useMinerAccount();
  return (
    <>
      <SEO/>
      <BannerTop/>
      <Header 
        withTopBanner={true}
        withAddonsLeft={isAuth}
        withSubAccounts={isAccounting}
        withAddonsCenter={!isAuth}
      />
      <MainLayout>
        <Landing/>
      </MainLayout>
      <Footer/>
      <JsonLdSchema />
    </>
  )
}

export const getServerSideProps = wrapper.getServerSideProps(withUserDataFromCookie);